import { colors } from '../utils'

/*
 * Check systems/index.js
 * We have a custom `shadows` scale the appends an rgba version of the themes shadow color
 */

export const createShadows = (color) => [
  `0px 2px 8px -4px ${colors.fade(color, 0.4)}`,
  `0px 3px 12px -4px ${colors.fade(color, 0.28)}`,
  `0px 4px 12px -2px ${colors.fade(color, 0.2)}`,
  `0px 4px 16px -2px ${colors.fade(color, 0.2)}`,
  `0 0.1px 0.6px -6px ${colors.fade(color, 0.029)},
0 0.2px 1.4px -6px ${colors.fade(color, 0.042)},
0 0.3px 2.5px -6px ${colors.fade(color, 0.051)},
0 0.5px 4px -6px ${colors.fade(color, 0.06)},
0 0.8px 6.2px -6px ${colors.fade(color, 0.069)},
0 1.2px 9.6px -6px ${colors.fade(color, 0.078)},
0 2px 16px -6px ${colors.fade(color, 0.091)},
0 4px 32px -6px ${colors.fade(color, 0.12)}`,
  `0 0.1px 0.6px -6px ${colors.fade(color, 0.038)},
0 0.3px 1.4px -6px ${colors.fade(color, 0.056)},
0 0.5px 2.5px -6px ${colors.fade(color, 0.069)},
0 0.8px 4px -6px ${colors.fade(color, 0.08)},
0 1.2px 6.2px -6px ${colors.fade(color, 0.091)},
0 1.8px 9.6px -6px ${colors.fade(color, 0.104)},
0 3px 16px -6px ${colors.fade(color, 0.122)},
0 6px 32px -6px ${colors.fade(color, 0.16)}`,
  `0 0.2px 0.8px -6px ${colors.fade(color, 0.038)},
0 0.4px 1.8px -6px ${colors.fade(color, 0.056)},
0 0.6px 3.2px -6px ${colors.fade(color, 0.069)},
0 1px 5px -6px ${colors.fade(color, 0.08)},
0 1.5px 7.7px -6px ${colors.fade(color, 0.091)},
0 2.4px 12.1px -6px ${colors.fade(color, 0.104)},
0 4px 20px -6px ${colors.fade(color, 0.122)},
0 8px 40px -6px ${colors.fade(color, 0.16)}`,
  `0 0.2px 1.1px -8px ${colors.fade(color, 0.048)},
0 0.5px 2.5px -8px ${colors.fade(color, 0.07)},
0 0.9px 4.4px -8px ${colors.fade(color, 0.086)},
0 1.5px 7px -8px ${colors.fade(color, 0.1)},
0 2.3px 10.8px -8px ${colors.fade(color, 0.114)},
0 3.6px 16.9px -8px ${colors.fade(color, 0.13)},
0 6px 28px -8px ${colors.fade(color, 0.152)},
0 12px 56px -8px ${colors.fade(color, 0.2)}`,
  `0 0.5px 1.1px -8px ${colors.fade(color, 0.038)},
0 1.1px 2.5px -8px ${colors.fade(color, 0.056)},
0 1.9px 4.3px -8px ${colors.fade(color, 0.069)},
0 3px 6.9px -8px ${colors.fade(color, 0.038)},
0 4.6px 10.6px -8px ${colors.fade(color, 0.091)},
0 7.2px 16.6px -8px ${colors.fade(color, 0.104)},
0 12px 27.5px -8px ${colors.fade(color, 0.122)},
0 24px 55px -8px ${colors.fade(color, 0.16)}`,
  `0 0.6px 1.5px -12px ${colors.fade(color, 0.038)},
0 1.4px 3.3px -12px ${colors.fade(color, 0.056)},
0 2.5px 5.8px -12px ${colors.fade(color, 0.069)},
0 4px 9.1px -12px ${colors.fade(color, 0.038)},
0 6.2px 14.1px -12px ${colors.fade(color, 0.091)},
0 9.6px 22px -12px ${colors.fade(color, 0.104)},
0 16px 36.5px -12px ${colors.fade(color, 0.122)},
0 32px 73px -12px ${colors.fade(color, 0.16)}`,
]
